import React, { useState, useEffect, useRef } from "react";
import { useData } from "../../../components/firebase/DataProvider";

import { analytics } from "../../../components/firebase/FirebaseProvider";
import { useHistory } from "react-router-dom";
import slugify from "slugify";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Button from "@material-ui/core/Button";
import useStyles from "./style/flashSaleStyle";
import SpesialOfferIcon from "../../../assets/icon/spesial-offer.svg";
import FlashSaleIcon from "../../../assets/icon/flashSaleIcon.svg";
import Countdown from "react-countdown";
import { upperFirst } from "lodash";
import ScrollContainer from "react-indiana-drag-scroll";
import { DialogTitle, IconButton } from "@material-ui/core";

function DialogFlashsale({ open, handleClose, data, keywords, timer, mode }) {
  const classes = useStyles();
  const history = useHistory();
  const { level } = useData();
  const [selected, setSelected] = useState("all");
  const [products, setProducts] = useState(data);
  const firstMount = useRef(true);
  useEffect(() => {
    if (!firstMount.current) {
      if (selected === "all") {
        setProducts(data);
      } else {
        const filteredProducts = data?.filter(
          (elm) => elm?.kategori1?.id === selected
        );
        setProducts(filteredProducts);
      }
    } else {
      firstMount.current = false;
    }
  }, [selected]);

  const toDetailProduct = (id, title) => () => {
    analytics.logEvent("view_product", { name: title, id: id });
    history.push(`/produk/${slugify(title.toLowerCase())}/${id}`);
  };

  const Renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <>
        <div
          style={{
            borderRadius: "4px",
            padding: "0px 5px",
            backgroundColor: "rgb(239, 241, 254)",
          }}
        >
          <Typography color="primary" style={{ fontSize: "13px" }}>
            {days > 9 ? days : `0${days}`}
          </Typography>
        </div>
        <Typography
          color="primary"
          style={{ fontSize: "13px", fontWeight: "bold", margin: "0px 2.5px" }}
        >
          :{" "}
        </Typography>
        <div
          style={{
            borderRadius: "4px",
            padding: "0px 5px",
            backgroundColor: "rgb(239, 241, 254)",
          }}
        >
          <Typography color="primary" style={{ fontSize: "13px" }}>
            {hours > 9 ? hours : `0${hours}`}
          </Typography>
        </div>
        <Typography
          color="primary"
          style={{ fontSize: "13px", fontWeight: "bold", margin: "0px 2.5px" }}
        >
          :{" "}
        </Typography>
        <div
          style={{
            borderRadius: "4px",
            padding: "0px 5px",
            backgroundColor: "rgb(239, 241, 254)",
          }}
        >
          <Typography color="primary" style={{ fontSize: "13px" }}>
            {minutes > 9 ? minutes : `0${minutes}`}
          </Typography>
        </div>
        <Typography
          color="primary"
          style={{ fontSize: "13px", fontWeight: "bold", margin: "0px 2.5px" }}
        >
          :{" "}
        </Typography>
        <div
          style={{
            borderRadius: "4px",
            padding: "0px 5px",
            backgroundColor: "rgb(239, 241, 254)",
          }}
        >
          <Typography color="primary" style={{ fontSize: "13px" }}>
            {seconds > 9 ? seconds : `0${seconds}`}
          </Typography>
        </div>
      </>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={handleClose}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>{mode}</Typography>
        </div>
      </DialogTitle>
      <DialogContent dividers style={{ padding: 0 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#5675D3",
            color: "#fff",
          }}
        >
          {mode == "Flashsale" ? (
            <img src={FlashSaleIcon} alt="icon" style={{ width: "80px" }} />
          ) : mode == "Special Offers" ? (
            <img src={SpesialOfferIcon} alt="icon" style={{ width: "80px" }} />
          ) : (
            ""
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 5,
            color: "black",
            marginTop: 5,
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          <Typography style={{ fontSize: 15, marginRight: 20 }}>
            Berakhir Dalam{" "}
          </Typography>
          <Countdown date={timer} renderer={Renderer} />
        </div>{" "}
        <div
          style={{
            display: "flex",
            backgroundColor: "white",
            alignItems: "center",
            padding: "10px 10px",
            color: "black",
          }}
        >
          <Typography style={{ fontSize: 15, fontWeight: "bold" }}>
            Kategori Menarik Lainnya
          </Typography>
        </div>
        <ScrollContainer
          style={{
            display: "flex",
            overflowX: "auto",
            flexWrap: "nowrap",
            margin: "5px 10px",
          }}
        >
          {keywords?.map((item) => {
            return (
              <div style={{ marginRight: "10px" }}>
                <Button
                  fullWidth
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    setSelected(item?.[1]);
                  }}
                  style={{ padding: "5px 10px", borderRadius: 12 }}
                >
                  <Typography
                    noWrap
                    color={item?.[1] === selected ? "primary" : ""}
                    style={{ textTransform: "capitalize", fontSize: 13 }}
                    variant="button"
                  >
                    {item?.[0]}
                  </Typography>
                </Button>
              </div>
            );
          })}
        </ScrollContainer>
        <Grid container className={classes.rootDialog}>
          {products.map((item) => {
            return (
              <div className={classes.wrapper} key={item.id}>
                <Card className={classes.card}>
                  <CardActionArea onClick={toDetailProduct(item.id, item.nama)}>
                    {item?.textBadgePromo && (
                      <div className={classes.label}>
                        <Typography className={classes.txtLabel}>
                          {item.textBadgePromo}
                        </Typography>
                        <Typography className={classes.txtLabel}>
                          OFF
                        </Typography>
                      </div>
                    )}
                    {item.totalStock < 1 && (
                      <div className={classes.empty}>
                        <span className={classes.txtEmpty}>Stok Habis</span>
                      </div>
                    )}
                    {item.thumbnail?.length > 0 ? (
                      <div
                        loading="lazy"
                        className={classes.img}
                        style={{
                          backgroundImage: `url(${item?.thumbnail?.[0]})`,
                        }}
                      />
                    ) : (
                      <div
                        loading="lazy"
                        className={classes.img}
                        style={{
                          backgroundImage: `url(${item?.thumbnail?.[0]})`,
                        }}
                      />
                    )}
                  </CardActionArea>
                  <div className={classes.contentWrapperFlash}>
                    <div className={classes.contentFlash}>
                      <div style={{ display: "flex" }}>
                        <div className={classes.labelFlash}>{mode}</div>
                        {item?.properties?.type === "preorder" &&
                        item?.properties.end_at?.seconds * 1000 > Date.now() ? (
                          <div className={classes.labelPre}>Pre Order</div>
                        ) : null}
                      </div>{" "}
                      <Typography className={classes.title} component="p">
                        {item?.nama}
                      </Typography>
                      <Typography
                        className={classes.txtLabelharhag}
                        component="p"
                      >
                        Harga {upperFirst(level.level)}
                      </Typography>
                      <Typography className={classes.price} component="p">
                        {item.priceAfterPromoStr || item.priceStr}
                      </Typography>
                      <div className={classes.labelKomisi}>
                        {item.komisiValueStr} Komisi
                      </div>
                    </div>
                    <div className={classes.btnWrap}>
                      {item.totalStock < 1 ? (
                        <Button
                          fullWidth
                          variant="contained"
                          color="secondary"
                          size="small"
                          className={classes.btn}
                          style={{
                            backgroundColor: "rgb(255, 107, 107)",
                          }}
                        >
                          Stok Habis
                        </Button>
                      ) : (
                        <Button
                          fullWidth
                          variant="contained"
                          color="primary"
                          size="small"
                          className={classes.btn}
                          onClick={toDetailProduct(item?.id, item?.nama)}
                        >
                          Beli
                        </Button>
                      )}
                    </div>
                  </div>
                </Card>
              </div>
            );
          })}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default DialogFlashsale;
